import { useState } from "react";
import { toast } from "sonner";
import { FileSpreadsheet } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";

const cell = (v) => {
  const s = v == null ? "" : String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};
const pick = (r, i) => {
  const t = r.top3[i] || {};
  return [t.number, t.name, t.price, t.sp, t.finish];
};
const HEAD = ["Date", "Time (AEST)", "Venue", "Race", "Race name", "Preferred", "Starters",
  ...[1, 2, 3].flatMap((n) => [`Top ${n} no`, `Top ${n} horse`, `Top ${n} our price`, `Top ${n} SP`, `Top ${n} finish`]),
  "Winner no", "Winner", "Winner SP", "Result source"];

export const toCsv = (races) => [HEAD, ...races.map((r) => [
  r.date, r.start_aest, r.venue, r.race_number, r.race_name, r.preferred ? "Yes" : "No", r.has_result ? r.starters : "",
  ...pick(r, 0), ...pick(r, 1), ...pick(r, 2),
  r.winner?.number, r.winner?.name, r.winner?.sp, r.result_source,
])].map((row) => row.map(cell).join(",")).join("\n");

export const ResultsCsvButton = ({ scope }) => {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.get("/results", { params: { scope, period: "all" } });
      const done = data.races.filter((r) => r.has_result);
      const url = URL.createObjectURL(new Blob([`\uFEFF${toCsv(done)}`], { type: "text/csv;charset=utf-8" }));
      const a = Object.assign(document.createElement("a"), { href: url, download: `winners-places-${scope}-since-${data.tracking_from}.csv` });
      document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
      toast.success(`Exported ${done.length} races with results`);
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <Button variant="outline" onClick={run} disabled={busy} data-testid="results-export-csv">
      <FileSpreadsheet className="h-4 w-4 mr-2" />{busy ? "Exporting..." : "Export CSV"}
    </Button>
  );
};
